/** Product screens subscribe only to the data they use. */
const commerceScopes = new Set([
  'assist/help_tickets',
  'billing/profile_wallet_balances', 'billing/subscriptions',
  'discovery/discover_chefs',
  'marketplace/carts', 'marketplace/marketplace_orders',
  'menu/chef_menus', 'menu/dish_favourites', 'menu/dishes', 'menu/meal_categories',
  'menu/meal_plans', 'menu/meal_plan_entries', 'menu/meal_plan_cycles',
  'menu/trending_chefs', 'menu/trending_dishes',
  'message/order_messages', 'message/order_threads',
  'profile/chow_profiles', 'profile/vendor_profiles', 'profile/vendor_locations',
  'wallet/wallet_transactions',
])

export const usesCommerceProjection = (domain: string, collection: string): boolean =>
  commerceScopes.has(`${domain}/${collection}`)
